"use strict";

var _regeneratorRuntime = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _classCallCheck = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dayjs_1 = __importDefault(require("dayjs"));

var isoWeek_1 = __importDefault(require("dayjs/plugin/isoWeek"));

var firestore_1 = require("firebase/firestore");

var Espace_1 = __importDefault(require("../../Model/Espace"));

dayjs_1.default.extend(isoWeek_1.default);

var Produit = /*#__PURE__*/function (_Espace_1$default) {
  _inherits(Produit, _Espace_1$default);

  var _super = _createSuper(Produit);

  function Produit(props) {
    _classCallCheck(this, Produit);

    return _super.call(this, _objectSpread(_objectSpread({}, props), {}, {
      addButtonLabel: 'Ajouter un produit',
      collectionName: 'produits',
      tabs: [{
        itemMode: 'grid',
        label: 'Tous les produits',
        pathname: "/espaces/".concat(props.espaceId, "/produits/")
      }, {
        label: 'Caché',
        pathname: "/espaces/".concat(props.espaceId, "/produits/cache/"),
        wheres: {
          hidden: true
        }
      }, {
        label: 'En stock',
        pathname: "/espaces/".concat(props.espaceId, "/produits/en-stock/"),
        wheres: {
          hasInventory: true,
          qtyAvailable: {
            operator: '>',
            value: 0
          }
        }
      }, {
        label: 'Réservé',
        pathname: "/espaces/".concat(props.espaceId, "/produits/reserve/"),
        wheres: {
          hasInventory: true,
          qtyReserved: {
            operator: '>',
            value: 0
          }
        }
      }, {
        label: 'Rupture de stock',
        pathname: "/espaces/".concat(props.espaceId, "/produits/rupture-de-stock/"),
        wheres: {
          hasInventory: true,
          qtyAvailable: 0
        }
      }, {
        label: 'Sans inventaire',
        pathname: "/espaces/".concat(props.espaceId, "/produits/sans-inventaire/"),
        wheres: {
          hasInventory: false
        }
      }, {
        label: 'Créneaux',
        pathname: "/espaces/".concat(props.espaceId, "/produits/creneaux/"),
        wheres: {
          qtySlots: {
            operator: '>',
            value: 0
          }
        }
      }],
      title: 'name'
    }));
  }

  _createClass(Produit, [{
    key: "duplicate",
    value: function () {
      var _duplicate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, data) {
        var sku;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.generateNextSku();

              case 2:
                sku = _context.sent;
                return _context.abrupt("return", _get(_getPrototypeOf(Produit.prototype), "duplicate", this).call(this, id, _objectSpread(_objectSpread({}, data), {}, {
                  sku: sku
                })));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function duplicate(_x, _x2) {
        return _duplicate.apply(this, arguments);
      }

      return duplicate;
    }()
  }, {
    key: "findPrices",
    value: function () {
      var _findPrices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var ref, constraints, q, querySnapshot;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ref = (0, firestore_1.collection)(this.getCollectionRef(), id, 'prices');
                constraints = [(0, firestore_1.where)('deleted', '==', false), (0, firestore_1.where)('hidden', '==', false)];
                q = (0, firestore_1.query).apply(void 0, [ref].concat(constraints));
                _context2.next = 5;
                return (0, firestore_1.getDocs)(q);

              case 5:
                querySnapshot = _context2.sent;
                return _context2.abrupt("return", querySnapshot.docs.map(function (d) {
                  return _objectSpread({
                    id: d.id
                  }, d.data());
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function findPrices(_x3) {
        return _findPrices.apply(this, arguments);
      }

      return findPrices;
    }()
  }, {
    key: "findStockById",
    value: function () {
      var _findStockById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var documentSnapshot, constaints, q, querySnapshot;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, firestore_1.getDoc)((0, firestore_1.doc)(this.getCollectionRef(), id));

              case 2:
                documentSnapshot = _context3.sent;

                if (!(!documentSnapshot || !documentSnapshot.exists() || documentSnapshot.get('deleted'))) {
                  _context3.next = 5;
                  break;
                }

                throw new Error("Le document n'existe pas ou a été supprimé");

              case 5:
                constaints = [(0, firestore_1.where)('deleted', '==', false), (0, firestore_1.orderBy)('createdAt', 'desc')];
                q = (0, firestore_1.query).apply(void 0, [(0, firestore_1.collection)(documentSnapshot.ref, 'stocks')].concat(constaints));
                _context3.next = 9;
                return (0, firestore_1.getDocs)(q);

              case 9:
                querySnapshot = _context3.sent;
                return _context3.abrupt("return", querySnapshot.docs.map(function (d) {
                  return _objectSpread({
                    id: d.id
                  }, d.data());
                }));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function findStockById(_x4) {
        return _findStockById.apply(this, arguments);
      }

      return findStockById;
    }()
  }, {
    key: "clean",
    value: function clean(values, validate) {
      return _get(_getPrototypeOf(Produit.prototype), "clean", this).call(this, _objectSpread(_objectSpread({}, values), {}, {
        depth: values.depth && Number(values.depth),
        foldedDepth: values.foldedDepth && Number(values.foldedDepth),
        foldedHeight: values.foldedHeight && Number(values.foldedHeight),
        foldedWidth: values.foldedWidth && Number(values.foldedWidth),
        hasInventory: Boolean(values.hasInventory),
        height: values.height && Number(values.height),
        kind: values.kind || 'good',
        shipping2Carriers: Boolean(values.shipping2Carriers),
        shippingRisky: Boolean(values.shippingRisky),
        shippingSharing: values.shippingSharing && Number(values.shippingSharing),
        shippingSupport: values.shippingSupport && Number(values.shippingSupport),
        shippingVolume: values.shippingVolume && Number(values.shippingVolume),
        shippingWeight: values.shippingWeight && Number(values.shippingWeight),
        stackableByQty: values.stackableByQty && Number(values.stackableByQty),
        weight: values.weight && Number(values.weight),
        width: values.width && Number(values.width)
      }));
    }
  }, {
    key: "generateNextSku",
    value: function () {
      var _generateNextSku = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(date) {
        var debut, fin, constraints, q, querySnapshot, _querySnapshot$docs$d, sku;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                debut = date ? (0, dayjs_1.default)(date).format('YYWWd') : (0, dayjs_1.default)().format('YYWWd');
                fin = "".concat(parseInt(debut, 10), 1);
                constraints = [(0, firestore_1.where)('sku', '>', debut), (0, firestore_1.where)('sku', '<', fin)];

                if (this.espaceId) {
                  constraints.push((0, firestore_1.where)('boutique', '==', this.espaceId));
                }

                constraints.push((0, firestore_1.orderBy)('sku'));
                q = (0, firestore_1.query).apply(void 0, [this.getCollectionRef()].concat(constraints));
                _context4.next = 8;
                return (0, firestore_1.getDocs)(q);

              case 8:
                querySnapshot = _context4.sent;

                if (!(querySnapshot.size > 0)) {
                  _context4.next = 13;
                  break;
                }

                _querySnapshot$docs$d = querySnapshot.docs[querySnapshot.size - 1].data(), sku = _querySnapshot$docs$d.sku;

                if (!sku) {
                  _context4.next = 13;
                  break;
                }

                return _context4.abrupt("return", debut + "000".concat(parseInt(sku.substr(-3), 10) + 1).slice(-3));

              case 13:
                return _context4.abrupt("return", "".concat(debut, "001"));

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function generateNextSku(_x5) {
        return _generateNextSku.apply(this, arguments);
      }

      return generateNextSku;
    }()
  }, {
    key: "initialize",
    value: function initialize(data) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;

      return _get(_getPrototypeOf(Produit.prototype), "initialize", this).call(this, _objectSpread(_objectSpread({}, data), {}, {
        condition: (_a = data === null || data === void 0 ? void 0 : data.condition) !== null && _a !== void 0 ? _a : 'new',
        hasInventory: (_b = data === null || data === void 0 ? void 0 : data.hasInventory) !== null && _b !== void 0 ? _b : false,
        hidden: (_c = data === null || data === void 0 ? void 0 : data.hidden) !== null && _c !== void 0 ? _c : false,
        isALot: (_d = data === null || data === void 0 ? void 0 : data.isALot) !== null && _d !== void 0 ? _d : false,
        isDemountable: (_e = data === null || data === void 0 ? void 0 : data.isDemountable) !== null && _e !== void 0 ? _e : false,
        isFeatured: (_f = data === null || data === void 0 ? void 0 : data.isFeatured) !== null && _f !== void 0 ? _f : false,
        isFragile: (_g = data === null || data === void 0 ? void 0 : data.isFragile) !== null && _g !== void 0 ? _g : false,
        isHeavy: (_h = data === null || data === void 0 ? void 0 : data.isHeavy) !== null && _h !== void 0 ? _h : false,
        isPhysical: (_j = data === null || data === void 0 ? void 0 : data.isPhysical) !== null && _j !== void 0 ? _j : false,
        kind: (data === null || data === void 0 ? void 0 : data.kind) || 'good',
        qtyAvailable: (_k = data === null || data === void 0 ? void 0 : data.qtyAvailable) !== null && _k !== void 0 ? _k : 0,
        qtyByNumber: (_l = data === null || data === void 0 ? void 0 : data.qtyByNumber) !== null && _l !== void 0 ? _l : 1,
        qtyMin: (_m = data === null || data === void 0 ? void 0 : data.qtyMin) !== null && _m !== void 0 ? _m : 1,
        qtyPrices: (_o = data === null || data === void 0 ? void 0 : data.qtyPrices) !== null && _o !== void 0 ? _o : 0,
        qtyReserved: (_p = data === null || data === void 0 ? void 0 : data.qtyReserved) !== null && _p !== void 0 ? _p : 0,
        qtySlots: (_q = data === null || data === void 0 ? void 0 : data.qtySlots) !== null && _q !== void 0 ? _q : 0,
        shipping2Carriers: (_r = data === null || data === void 0 ? void 0 : data.shipping2Carriers) !== null && _r !== void 0 ? _r : false,
        shippingFloor: (_s = data === null || data === void 0 ? void 0 : data.shippingFloor) !== null && _s !== void 0 ? _s : 'valid',
        shippingMode: (_t = data === null || data === void 0 ? void 0 : data.shippingMode) !== null && _t !== void 0 ? _t : 'auto',
        shippingRisky: (_u = data === null || data === void 0 ? void 0 : data.shippingRisky) !== null && _u !== void 0 ? _u : false
      }));
    }
  }, {
    key: "secureUpdate",
    value: function () {
      var _secureUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, data) {
        var docRef, values;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                docRef = (0, firestore_1.doc)(this.getFirestore(), this.collectionName, id);
                values = {};

                if (undefined !== data.hidden) {
                  values.hidden = data.hidden;
                }

                if (undefined !== data.datetime) {
                  values.datetime = data.datetime;
                }

                if (!(Object.keys(values).length > 0)) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 7;
                return (0, firestore_1.updateDoc)(docRef, _objectSpread(_objectSpread({}, values), {}, {
                  updatedAt: (0, dayjs_1.default)().toISOString()
                }));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function secureUpdate(_x6, _x7) {
        return _secureUpdate.apply(this, arguments);
      }

      return secureUpdate;
    }()
  }], [{
    key: "calculNewQuantity",
    value: function calculNewQuantity(qty, oldQty, item) {
      var hasInventory = item.hasInventory,
          qtyAvailable = item.qtyAvailable,
          qtyMin = item.qtyMin,
          qtyByNumber = item.qtyByNumber,
          qtyMax = item.qtyMax;

      if (0 === qty) {
        return 0;
      }

      var addOp = qty > oldQty;
      var newQtyByNumber = qtyByNumber || 1;
      var newQtyMin = qtyMin ? Math.max(1, qtyMin, newQtyByNumber) : newQtyByNumber;
      var newQtyMax;

      if (hasInventory) {
        newQtyMax = qtyMax || 0;
      } else {
        newQtyMax = 1;
      }

      var newQty = qty || newQtyMin;
      newQtyMax -= newQtyMax % newQtyByNumber > 0 ? newQtyMax % newQtyByNumber : 0;

      if (newQty % newQtyByNumber > 0) {
        newQty -= newQty % newQtyByNumber;
        newQty += addOp ? newQtyByNumber : 0;
      }

      if (newQtyMin && newQty < newQtyMin) {
        newQty = newQtyMin;
      }

      if (newQtyMax > 0 && newQty > newQtyMax) {
        newQty = newQtyMax;
      }

      if (hasInventory && qtyAvailable && newQty > qtyAvailable) {
        newQty = qtyAvailable;
      }

      return newQty;
    }
  }, {
    key: "getDepth",
    value: function getDepth(item) {
      return Number(item.foldedDepth || item.depth || 0);
    }
  }, {
    key: "getHeight",
    value: function getHeight(item) {
      return Number(item.foldedHeight || item.height || 0);
    }
  }, {
    key: "getMaxQuantity",
    value: function getMaxQuantity(item) {
      var qtyAvailable = item.qtyAvailable || 0;
      var qtyMax = item.qtyMax ? Math.min(item.qtyMax, qtyAvailable) : qtyAvailable;
      qtyMax = !item.hasInventory ? 0 : qtyMax;
      return qtyMax;
    }
  }, {
    key: "getMinQuantity",
    value: function getMinQuantity(item) {
      var qtyAvailable = item.qtyAvailable || 0;
      var qtyMin = item.qtyMin || 0;
      var qtyByNumber = item.qtyByNumber || 1;
      return Math.max(1, Math.min(qtyMin, qtyAvailable), qtyByNumber);
    }
  }, {
    key: "getWidth",
    value: function getWidth(item) {
      return Number(item.foldedWidth || (item === null || item === void 0 ? void 0 : item.width) || 0);
    }
  }, {
    key: "calcDimensionMax",
    value: function calcDimensionMax(item) {
      var width = this.getWidth(item);
      var depth = this.getDepth(item);
      var height = this.getHeight(item);
      return width + depth + height;
    }
  }, {
    key: "calcVolume",
    value: function calcVolume(item) {
      var width = this.getWidth(item);
      var depth = this.getDepth(item);
      var height = this.getHeight(item);
      var shippingVolume = Number(item.shippingVolume || 0);
      return shippingVolume || width * depth * height / 1000000;
    }
  }, {
    key: "calcWeight",
    value: function calcWeight(item) {
      var shippingWeight = Number(item.shippingWeight || 0);
      var weight = Number(item.weight || 0);
      return shippingWeight || weight;
    }
  }]);

  return Produit;
}(Espace_1.default);

exports.default = Produit;